<div class="case-request-status-details">
  <div class="case-request-status-section">
    <div
      class="vo-heading-bold-16 mb-15"
      [innerHtml]="referenceDataLabels.OverviewIllustrationSelectedProductSubtitle | localizeLabel"
    ></div>
    <div class="vo-body-regular-14">
      {{ caseRequest.ProductDescription }}
    </div>
  </div>
  <div class="case-request-status-section">
    <div class="vo-heading-bold-16 mb-15" [innerHTML]="referenceDataLabels.KfiTitle | localizeLabel"></div>

    <div class="mb-20" *ngIf="illustrationPendingStatuses.includes(caseRequest.CurrentStatusCode)">
      <div class="d-flex mb-10">
        <div class="d-inline-block case-request-status-in-progress__loader"></div>
        <div class="vo-body-bold-14" [innerHtml]="referenceDataLabels.IllustrationPendingTitle | localizeLabel"></div>
      </div>
      <div
        class="vo-body-regular-14 ml-35"
        [innerHtml]="referenceDataLabels.IllustrationPendingDescription | localizeLabel"
      ></div>
    </div>

    <ng-container *ngIf="illustrationReadyStatuses.includes(caseRequest.CurrentStatusCode)">
      <div class="d-flex mb-10">
        <span class="vo-icon case-request-status-icon case-request-status__ready-icon mr-15"></span>
        <span class="vo-body-bold-14" [innerHtml]="referenceDataLabels.IllustrationReadyTitle | localizeLabel"></span>
      </div>
      <div class="ml-35">
        <div
          class="d-flex mb-15"
          [routerLink]="['/', interfaceTypeCode, 'caseOverview', caseIdAsHash, 'caseDocuments']"
          [queryParams]="{ DocumentId: caseRequest.DistributedCaseDocumentIDAsHash }"
        >
          <span class="vo-icon case-request-status-icon vo-icon-document mr-5"></span>
          <span
            class="vo-link fs-14"
            [innerHtml]="referenceDataLabels.IllustrationReadyCaseDocumentsLabel | localizeLabel"
          ></span>
        </div>

        <div *ngIf="!caseRequest.DistributedCaseDocumentID" class="ml-30">
          <div class="d-flex mb-5">
            <span class="vo-icon case-request-status-icon case-request-status__important-message-icon mr-15"></span>
            <span
              class="vo-body-bold-14"
              [innerHtml]="referenceDataLabels.NoCaseDocumentLinkedInfoTitle | localizeLabel"
            ></span>
          </div>
          <div
            class="vo-body-regular-12 ml-35 mb-15"
            [innerHtml]="referenceDataLabels.NoCaseDocumentLinkedInfoDescription | localizeLabel"
          ></div>
        </div>

        <div>
          <div class="d-flex mb-15">
            <span class="vo-icon case-request-status-icon vo-icon-switch mr-5"></span>
            <span
              class="fs-14"
              [ngClass]="{
                'vo-link': caseRequest.IsActiveProduct && areIllustrationsReady,
                'case-request-status-product-expired': !(caseRequest.IsActiveProduct && areIllustrationsReady)
              }"
              [innerHtml]="referenceDataLabels.IllustrationReadyGoToProductTransferLabel | localizeLabel"
              (click)="goToProductTransfer()"
            ></span>
          </div>
          <div *ngIf="!caseRequest.IsActiveProduct" class="d-flex align-items-center ml-30 mb-20">
            <span class="vo-icon case-request-status-icon case-request-status__error-icon mr-5"></span>
            <span
              class="fs-12"
              [innerHtml]="referenceDataLabels.IllustrationProductExpiredError | localizeLabel"
            ></span>
          </div>
          <div
            *ngIf="caseRequest.IsActiveProduct && !areIllustrationsReady"
            class="d-flex align-items-center ml-30 mb-20"
          >
            <span class="vo-icon case-request-status-icon case-request-status__error-icon mr-5"></span>
            <span class="fs-12" [innerHtml]="referenceDataLabels.IllustrationsNotReadyError | localizeLabel"></span>
          </div>

          <div
            *ngIf="caseRequest.IsActiveProduct && areIllustrationsReady && !caseRequest.HasDetailsToProceedToSwitch"
            class="ml-30"
          >
            <div class="d-flex mb-5">
              <span class="vo-icon case-request-status-icon case-request-status__important-message-icon mr-15"></span>
              <span
                class="vo-body-bold-14"
                [innerHtml]="referenceDataLabels.OverviewProductTransferInfoTitle | localizeLabel"
              ></span>
            </div>
            <div
              class="vo-body-regular-12 ml-35 mb-15"
              [innerHtml]="referenceDataLabels.OverviewProductTransferInfoDescription | localizeLabel"
            ></div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="illustrationManualStatuses.includes(caseRequest.CurrentStatusCode)">
      <div class="d-flex mb-10">
        <span class="vo-icon case-request-status-icon case-request-status__manual-processing-icon mr-15"></span>
        <span
          class="vo-body-bold-14"
          [innerHtml]="referenceDataLabels.IllustrationManualModeTitle | localizeLabel"
        ></span>
      </div>
      <div
        class="vo-body-regular-14 ml-35 mb-20"
        [innerHtml]="referenceDataLabels.IllustrationManualModeDescription | localizeLabel"
      ></div>
    </ng-container>

    <ng-container *ngIf="showImportantIllustrationInfo">
      <div class="d-flex mb-10">
        <span class="vo-icon case-request-status-icon case-request-status__important-message-icon mr-15"></span>
        <span
          class="vo-body-bold-14"
          [innerHtml]="referenceDataLabels.ImportantIllustrationTitle | localizeLabel"
        ></span>
      </div>
      <div
        class="vo-body-regular-14 ml-35"
        [innerHtml]="referenceDataLabels.ImportantIllustrationDescription | localizeLabel"
      ></div>
    </ng-container>
  </div>
</div>
